import React from "react";
import {Card} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import CardMedia from "@material-ui/core/CardMedia";

const useStyles = makeStyles((theme) => ({
    cardInner: {
        display: 'flex',
        // justifyContent: 'space-between',
    },
    image: {
        paddingRight: 10,
    },
    cardItem: {
        color: theme.palette.textColor,
        background: theme.palette.paperColor,
        padding: 10,
        width: '100%',
        '&:hover': {
            background: theme.palette.hoverColorItem,
        }
    },
    cardImage: {
        width: 80,
        height: 80,
        borderRadius: 0,
    },
    textWrapper: {},
    textWrapperInner: {},
    streamName: {
        fontFamily: 'Arial',
    },
    subInfoContainer: {},
    nowPlayingLabel: {
        fontSize: 12,
        opacity: 0.5,
        fontWeight: 'bold',
        marginBottom: 1,
        fontFamily: 'Arial',
    },
    nowPlaying: {
        fontSize: 11,
        opacity: 0.5,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        fontFamily: 'Arial',
    },
}));

const CardItem = (props) => {
    const classes = useStyles();
    const { image, title, subtitle, url, radio_id } = props;
    return(
        <Card
            key={props.key}
            className={clsx('card-item', classes.cardItem)}
        >
            <div className={classes.cardInner}>
                <div className={classes.image}>
                    <CardMedia
                        alt="Image not found"
                        component="img"
                        className={classes.cardImage}
                        image={`//i.ytimg.com/vi/Y5WQ6gF-8vA/hqdefault.jpg`}
                    />
                </div>
                <div className={classes.textWrapper}>
                    <div className={classes.textWrapperInner}>
                        <div className={classes.streamName}>{'test radio name'}</div>
                        <div className={classes.nowPlaying}>{'test radio subtitle'}</div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default CardItem;